import { useSettings } from '@capsicum/common';
import { useCredentialsQuery } from '@capsicum/socios-core';
import { useMemo } from 'react';

export type TParticipationRequirements = 'OWNED' | 'STAKED';

type UseParticipationRequirementReturn = {
	isLoading: boolean;
	requirement: TParticipationRequirements;
};

export const useParticipationRequirement = (): UseParticipationRequirementReturn => {
	const { areCredentialsLoading, credentials } = useCredentialsQuery();

	const {
		areSettingsLoading,
		settings: { fanTokenStakingEnabled, isTypeformStakedParticipationEnabled }
	} = useSettings();

	const canUserStake = useMemo(
		() => credentials?.find(credential => credential.code === 'CHZ:CHAIN_STAKING:STAKE')?.status === 'granted',
		[credentials]
	);

	return {
		isLoading: areSettingsLoading || areCredentialsLoading,
		requirement:
			canUserStake && fanTokenStakingEnabled.stake && isTypeformStakedParticipationEnabled ? 'STAKED' : 'OWNED'
	};
};
